




import { Vue, Component, Prop } from 'vue-property-decorator';
import Button from '../common/inputs/Button.vue';
import { downloadSearchResultsExcel } from '../../services/excel-service';

@Component({
  components: {
    appButton: Button
  }
})
export default class ExcelBtn extends Vue {
  async downloadExcel() {
    const excel = await downloadSearchResultsExcel();
  }
}
